export const dateKey = (date: Date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

export const initialFrom = () => {
  const date = new Date();
  date.setDate(date.getDate() - 6);
  return dateKey(date);
};

export const displayTime = (value: string | null) =>
  value
    ? new Intl.DateTimeFormat('he-IL', { dateStyle: 'short', timeStyle: 'short' }).format(new Date(value))
    : 'פתוחה';
